// @ts-nocheck
/**
 * mobx shim — no-op decorators + makeObservable replacement so legacy class
 * components that used MobX for *local* component state can keep their
 * decorators while we incrementally migrate them to React state.
 *
 * IMPORTANT: this is just an API shim. There is no reactivity — writes to
 * `@observable` fields do NOT trigger re-renders. Components that depend on
 * observable-driven re-renders must use this.setState instead.
 */

const identity = (target) => target;

export const observable = identity;
observable.deep = identity;
observable.shallow = identity;
observable.ref = identity;
observable.struct = identity;

export const action = identity;
action.bound = identity;

export const computed = identity;
computed.struct = identity;

export const makeObservable = () => undefined;
export const makeAutoObservable = () => undefined;
export const autorun = () => () => undefined;
export const reaction = () => () => undefined;
export const runInAction = (fn) => fn();
